/**
 * --------------------------------------------------------------------------
 * Ace (v4.0.0): index.js
 * --------------------------------------------------------------------------
 */

import Util from './util'
import EventHandler from './event-handler'
import Basic from './general'
import Scrollbar from './scrollbar'
import Sidebar from './sidebar'
import Aside from './aside'
import Toaster from './toaster'
import Card from './card'
import FileInput from './fileinput'
import Wysiwyg from './wysiwyg'
import { NavTabScroller, NavLinkScroller } from './tab-scroll'
import TabSwipe from './tab-swipe'
import ScrollTop from './scroll-top'
import Sticky from './sticky'

export default {
  Util,
  EventHandler,
  Basic,
  Scrollbar,
  Sidebar,
  Aside,
  Toaster,
  Card,
  FileInput,
  Wysiwyg,
  NavTabScroller,
  NavLinkScroller,
  TabSwipe,
  ScrollTop,
  Sticky
}
